import React from "react";

import { SIGN_IN_SITE } from "../client";
import AuthPage from "./AuthPage";
import SignInOnSite from "./SignInOnSite";

export default function SignupPage() {
  return SIGN_IN_SITE ? <SignInOnSite site={SIGN_IN_SITE} mode="signup" /> : <AuthPage mode="signup" />;
}
